import Breakpoints from "common/helper/Breakpoints";

export default {
    _configMobileColumns: function(options) {
        (options.columns || [])
        .filter(function(col) {
                return col.phone === false;
            })
            .forEach(function(col) {
                col.media = Breakpoints.NOT_PHONE_QUERY;
            })
    },

    _detachColumnMediaResizeHandler: function() {
        //This is a workaround for a bug in kendo's version of this function. Its calling on() instead of off().
        //This should be removed once that is fixed.
        if (this._columnMediaResizeHandler) {
            $(window).off("resize.kendoGrid", this._columnMediaResizeHandler);
        }
    }
}
